<template>
  <div class="ecm__banner section__padding">
    <div class="ecm__banner-desc">
      <p>Hai. Welcome to <span class="logo--title">BukuBook</span></p>
      <h3>FIND YOUR DREAM BOOK NOW</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner'
}
</script>

<style lang="scss" scoped>
.ecm__banner {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  background: linear-gradient(315deg, rgba(12,7,82,0.804359243697479) 0%, rgba(66,125,240,0.14889705882352944) 100%),
              url("https://images.unsplash.com/photo-1551029506-0807df4e2031?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1034&q=80");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 450px;
  .ecm__banner-desc {
    width: 700px;
    p {
      color: white;
      font-size: 30px;
      margin-bottom: 7px;
      cursor: default;
      span {
        color: white;
      }
    }
    h3 {
      cursor: default;
      color: white;
      font-size: 45px;
      line-height: 1.1;
      font-weight: 550;
    }
  }
}

@media screen and (max-width: 1024px) {
  .ecm__banner {
    height: 360px;
    .ecm__banner-desc {
      width: 500px;
      p {
        font-size: 25px;
      }
      h1 {
        font-weight: bold;
        font-size: 35px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .ecm__banner {
    height: 300px;
    .ecm__banner-desc {
      p {
        font-size: 20px;
      }
      h1 {
        font-size: 30px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .ecm__banner {
    height: 200px;
    justify-content: center;
    .ecm__banner-desc {
      text-align: center;
      p {
        font-size: 15px;
      }
      h1 {
        font-size: 20px;
      }
    }
  }
}

@media screen and (max-width: 320px) {
  .ecm__banner {
    height: 180px;
    justify-content: center;
    .ecm__banner-desc {
      text-align: center;
      p {
        font-size: 14px;
      }
      h1 {
        font-weight: bold;
        font-size: 19px;
      }
    }
  }
}
</style>
